module.exports = __webpack_public_path__ + "static/media/thumbnailView.68099772.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/thumbnailView.svg
// module id = 636
// module chunks = 0